import React from 'react';

export const message = (
    <svg width="16" height="14" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16 5.83269C16 2.60649 12.4196 0 8 0C3.58036 0 0 2.6156 0 5.83269C0 7.68275 1.17857 9.33231 3.01786 10.3986C2.59821 11.9206 1.95536 12.4674 1.39286 13.1144C1.25893 13.2785 1.10714 13.4152 1.15179 13.643C1.15179 13.643 1.15179 13.643 1.15179 13.6521C1.19643 13.8709 1.38393 14.0167 1.58036 13.9985C1.92857 13.9529 2.27679 13.8891 2.59821 13.798C4.14286 13.397 5.53571 12.6497 6.70536 11.5925C7.125 11.638 7.5625 11.6654 8 11.6654C12.4196 11.6654 16 9.0589 16 5.83269Z"
            fill="#62646A"
        />
    </svg>
);
